import axios from 'axios';
import apiConfig from '../api.config';

export default function userRequest({ userId }) {
  const {
    host,
    URIs: { user },
  } = apiConfig;

  const uri = `${host}${user}/${userId}`;

  return axios
    .get(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
